// Thin wrapper around the Umami tracking script loaded in index.html.
//
// Umami exposes `window.umami.track(name, data?)` once the script finishes
// loading. We defer the call so event fires even if our code runs before
// the script is ready (deferred <script>), and we silently swallow errors
// so a missing script, blocked request, or offline state never breaks the
// user-facing flow.
//
// Privacy contract: we never send photo bytes, landmark data, or anything
// that could identify the user. Only anonymised interaction metadata — the
// name of a look picked, the brand of a product clicked, etc.

type UmamiApi = {
  track: (name: string, data?: Record<string, unknown>) => void;
};

type WindowWithUmami = Window & { umami?: UmamiApi };

export function track(
  event: string,
  data?: Record<string, string | number | boolean>
): void {
  try {
    const w = window as WindowWithUmami;
    if (w.umami && typeof w.umami.track === 'function') {
      w.umami.track(event, data);
    }
  } catch {
    // Never let analytics errors affect the user experience.
  }
}
